<template>
  <header class="page-hero">
    <div
      class="flex flex-col gap-3 md:flex-row md:items-end md:justify-between"
    >
      <div class="min-w-0 text-left">
        <p class="text-xs font-bold uppercase text-blue-100">
          {{ eyebrow }}
        </p>
        <p class="mt-1.5 text-lg font-black leading-tight md:text-xl">
          {{ title }}
        </p>
        <p
          v-if="description"
          class="mt-2 max-w-2xl text-xs font-semibold leading-5 text-blue-50"
        >
          {{ description }}
        </p>
      </div>
      <div v-if="$slots.actions" class="shrink-0">
        <slot name="actions" />
      </div>
    </div>
  </header>
</template>

<script lang="ts">
export default {
  props: {
    eyebrow: { type: String, default: "" },
    title: { type: String, default: "" },
    description: { type: String, default: "" },
  },
};
</script>
